import React from 'react';
import { useFormTab } from '~/pages/CardSaga/components/providers/FormTabProvider';
import PropTypes from 'prop-types';
import { useErrorPicture } from '~/hooks/useErrorPicture';
import { IMG_WIDTH, IMG_HEIGHT } from '~/config/constants';
import { IMAGE_NOT_AVAILABLE } from '~/config/constants';
import classNames from 'classnames/bind';
const cx = classNames.bind();
import Replacement from './Replacement';
import { addVersionId } from '~/utils/helpers';
import { useImageNotAvailable } from '~/hooks/useImageNotAvailable';

function CardFrame({ id, cardFrame, replacements, children }) {
    const { cardFrontRef } = useFormTab();

    const err = useErrorPicture(cardFrame);
    const img = useImageNotAvailable(cardFrame);

    return (
        <div
            style={{
                textAlign: 'center',
                width: IMG_WIDTH,
                height: IMG_HEIGHT,
            }}
            className={cx('font-face-aAtmospheric', {
                'border border-dark rounded': img === IMAGE_NOT_AVAILABLE || err,
            })}
            id={id}
            ref={cardFrontRef}
        >
            <img
                src={err || !cardFrame ? IMAGE_NOT_AVAILABLE : addVersionId(cardFrame)}
                className="position-relative"
                style={{ width: '100%', top: 0, left: 0, height: '100%' }}
                crossOrigin="anonymous"
            />
            <Replacement replacements={replacements} />

            {children}
        </div>
    );
}

CardFrame.defaultProps = {
    cardFrame: '',
    replacements: [],
};

CardFrame.propTypes = {
    id: PropTypes.string.isRequired,
    cardFrame: PropTypes.string,
    replacements: PropTypes.array,
    children: PropTypes.node.isRequired,
};

export default React.memo(CardFrame);
